import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlagTriangleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.46 1.958a.62.62 0 0 0-.618-.625.62.62 0 0 0-.62.625v12.083a.62.62 0 0 0 .62.625.62.62 0 0 0 .619-.625v-3.57l9.928-3.58a.593.593 0 0 0 0-1.115L3.46 2.195zm0 1.565 7.793 2.81-7.792 2.81z" })
});
export default SvgFlagTriangleRegularIcon;
